import { useState } from 'react'

import Image, { ImageProps } from 'next/image'

interface ImageWithFallbackProps extends Omit<ImageProps, 'onError' | 'src'> {
  fallbackSrc: string
  src?: string
}

export const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  fallbackSrc,
  ...rest
}) => {
  const [imgSrc, setImgSrc] = useState(src ?? fallbackSrc)

  return (
    <Image
      {...rest}
      src={imgSrc}
      onError={() => {
        setImgSrc(fallbackSrc)
      }}
    />
  )
}

interface ImageWithFallbackComponentProps extends Omit<ImageProps, 'onError'> {
  fallbackComponent: React.ReactNode
  src: string
}

export const ImageWithFallbackComponent: React.FC<
  ImageWithFallbackComponentProps
> = ({ fallbackComponent, ...rest }) => {
  const [error, setError] = useState(false)

  if (error) {
    return <>{fallbackComponent}</>
  }

  return (
    <Image
      {...rest}
      onError={() => {
        setError(true)
      }}
    />
  )
}
